import Vue from 'vue'
import Clipboard from 'clipboard'
import _ from 'lodash'

function clipboardSuccess() {
  Vue.prototype.$message({
    message: '复制成功！',
    type: 'success',
    duration: 1500
  })
}

function clipboardError() {
  Vue.prototype.$message({
    message: '复制失败！',
    type: 'error'
  })
}

export default function handleClipboard(_text, opt = {}, className = '#app') {
  let text = _text
  if (_.isEmpty(text)) {
    return
  }
  if (Array.isArray(text) && text.every(item => typeof item === 'string')) { // ['a', 'b', 'c']=> 'a,b,c'
    text = text.join(opt.split || ',')
  } else if (typeof text === 'object' && text !== null && !Array.isArray(text)) { // {a:1, b:2, c:3} => 'a:1,b:2,c:3'
    text = Object.entries(text).map(([key, value]) => `${key}:${value}`).join(opt.split || ',')
  }
  const clipboard = new Clipboard(className, {
    text: () => text
  })
  clipboard.on('success', () => {
    clipboardSuccess()
    // clipboard.off('error')
    // clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    clipboardError()
    // clipboard.off('error')
    // clipboard.off('success')
    clipboard.destroy()
  })
  // clipboard.onClick(event)
}
